import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { FIREARM_STORAGE_LOCATION_TYPE, FirearmStorageLocation } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class FirearmStorageLocationServiceBase extends CrudService<FirearmStorageLocation, number> {

  servicePath: string = '/firearmstoragelocation';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, FIREARM_STORAGE_LOCATION_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<FirearmStorageLocation>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<FirearmStorageLocation>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



